import { useReq } from '@/utils/request/useReq'

const listUrl = '/activity/ipo/homepage/list'
const list = (params = {}, options = {}) =>
  useReq(listUrl, { method: 'POST', data: params, auth: false }, options)

const detailUrl = '/activity/ipo/homepage/detail'
const detail = (params = {}, options = {}) =>
  useReq(detailUrl, { method: 'POST', data: params, auth: false }, options)

const subscribeUrl = '/activity/ipo/subscribe'
const subscribe = (params = {}, options = {}) =>
  useReq(subscribeUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const mySubscriptionsUrl = '/activity/ipo/subscription/my'
const mySubscriptions = (params = {}, options = {}) =>
  useReq(mySubscriptionsUrl, { method: 'POST', data: params }, options)

const confirmPaymentUrl = '/activity/ipo/subscription/confirmPayment'
const confirmPayment = (params = {}, options = {}) =>
  useReq(confirmPaymentUrl, { method: 'POST', data: params }, { immediate: false, ...options })

const hkdUsdtRateUrl = '/activity/ipo/hkdUsdtRate'
const hkdUsdtRate = (params = {}, options = {}) =>
  useReq(hkdUsdtRateUrl, { method: 'GET', params, auth: false }, { immediate: false, ...options })

const pendingPaymentCountUrl = '/activity/ipo/subscription/pendingPaymentCount'
const pendingPaymentCount = (options = {}) =>
  useReq(pendingPaymentCountUrl, { method: 'POST', data: {} }, { immediate: false, ...options })

const needLoginUrl = [subscribeUrl, mySubscriptionsUrl, confirmPaymentUrl, pendingPaymentCountUrl]

export default {
  list,
  detail,
  subscribe,
  mySubscriptions,
  confirmPayment,
  hkdUsdtRate,
  pendingPaymentCount,
  needLoginUrl,
}
